import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useMounted } from '@app/hooks/useMounted';
import { getReports, Report } from '@app/api/reports.api';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { GlobalSpinner } from '@app/components/common/GlobalSpinner/GlobalSpinner';
import { themeObject } from '@app/styles/themes/themeVariables';
import ShortcutMenuWrapper, { MenuDetailsProps } from '../ShortcutNavigator/ShortcutMenuWrapper';
import ReportMenuIcon from "assets/menus/temp/report--b.grey.svg";
import ReportingMenuIcon from "assets/menus/temp/category.svg";
import ReportingHeaderIcon from "assets/menus/temp/reporting.svg";
import { BaseActionsWrapper } from '@app/components/common/BaseActionsWrapper/BaseActionsWrapper';
import { GlobalBackButton } from '@app/components/global/GlobalBackButton';

export const ReportListing: React.FC = () => {
    const { t } = useTranslation();
    const { isMounted } = useMounted();
    const [reports, setReports] = useState<MenuDetailsProps[]>([]);
    const { id } = useParams();
    const reportMenus = useAppSelector((state) => state.reportMenus.reportMenus);
    const [reportTitle, setReportTitle] = useState<string>('');
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getReportsByCategory = async (categoryId: number) => {
        console.log(categoryId);
        setLoading(true);
        try {
            await getReports(categoryId).then((res) => {
               
               if (isMounted.current) { 
                if (res && res.data) {
                    const reports = res.data.map((report: Report): MenuDetailsProps => {
                        return {
                            title: report.name,
                            icon: ReportMenuIcon,
                            url: report.isExternalLink ? report.externalUrl : `/reports/${id}/${report.systemName}`,
                            categoryIcon: ReportingMenuIcon
                        }
                    });
                    setReports(reports);
                }
               } 
            }).finally(() => setLoading(false));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const loadReportTitle = async (id: number) => {
        if (reportMenus && reportMenus.length > 0) {
            setReportTitle(reportMenus.find((reportMenu) => reportMenu.Id === id)?.name || '');
        }
    }
    
    useEffect(() => {
        loadReportTitle(parseInt(id?.toString() || '0'));
        getReportsByCategory(parseInt(id?.toString() || '0'));
    }, [isMounted]);

    const navigateToReport = (systemName: string) => {
        navigate(`/reports/${id}/${systemName}`);
    }
    
    return (
        <>
        {isLoading && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <GlobalSpinner color={themeObject['dark'].spinnerBase} />
            </div>
        )}
        <ShortcutMenuWrapper
          title={reportTitle}
          icon={ReportingHeaderIcon}
          menus={reports} />
        <BaseActionsWrapper>
            <GlobalBackButton />
        </BaseActionsWrapper>
        </>
    );
}